module.exports = __webpack_public_path__ + "static/media/heroGraphic.2e402a6d.png";